<template>
  <section>
    <h2 class="h2Title">페이지 등록</h2>
    <div class="formInfo">
      <v-form ref="formPage">
        <dl class="infoCont">
          <dt class="formInfoTxt">제목 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
          <dd class="formInfoArea">
            <v-col class="mgr" sm="6">
              <v-text-field v-model="page.title" :rules="[rules.required]" label="" dense solo outlined flat clearable/>
            </v-col>
          </dd>
        </dl>
        <dl class="infoCont">
          <dt class="formInfoTxt"> 페이지 사용 여부</dt>
          <dd class="formInfoArea">
            <v-col class="mgr" sm="6">
              <v-switch
                  v-model="page.activated"
                  flat
                  color="primary"
                  :label="page.activated ? '사용' : '사용안함'"
              ></v-switch>
            </v-col>
          </dd>
        </dl>

        <dl class="infoCont">
          <dt class="formInfoTxt">상세내용</dt>
          <dd class="formInfoArea">
            <v-col class="mgr">
              <editor-component
                  ref="contents"
                  :val="page.contents"
                  :uploaded="fileMeta"
                  @callback-upload="uploadImage"
                  label="상세 내용"/>
            </v-col>
          </dd>
        </dl>

      </v-form>
    </div>
    <div class="btnStyleBx">
      <div class="btnCommon justify-center">
        <v-btn class="vBtn" color="#1991eb" dark @click="save">
          <v-icon left>mdi mdi-content-save</v-icon>
          저장
        </v-btn>
        <v-btn class="vBtn" color="#fafafa" @click="goList()">
          <v-icon left>mdi mdi-format-list-bulleted</v-icon>
          목록
        </v-btn>
      </div>
    </div>


  </section>
</template>

<script>
import pageApi from '@/api/PageApi'

import EditorComponent from "../component/EditorComponent";

// import _ from 'lodash';

export default {
  name: "PageForm",
  components: {
    'editor-component': EditorComponent,
  },
  props: {
    id: String
  },
  data: () => ({
    rules: {
      required: value => !!value || '필수 입력 항목입니다..',
      qtZero: value => value && value > 0 || '필수 입력 항목입니다.'
    },
    page: {
      title: null,
      contents: null,
      activated: true
    },
    imageFileUrl: null,
    endPoint: process.env.VUE_APP_ATTACH_FILE_SERVER_URL,
    fileMeta: {},
  }),
  computed: {
  },
  methods: {
    uploadImage(f) {
      pageApi.uploadImage(f).then(res => {
        this.fileMeta = res;
      });
    },
    goList() {
      this.$router.push({path: '/page'})
    },
    async save() {

      if (!await this.$refs.formPage.validate())
        return;

      this.page.contents = this.$refs.contents.getValue();

      pageApi.save(this.page).then(data => {
        if (data) {
          if (this.page.pageId) {
            alert("수정되었습니다.");
          } else {
            alert("등록되었습니다.");
          }
          this.goList();
        } else {
          alert("Error");
        }
      });
    }

  },
  created() {
    if (this.$route.params.pageId) {
      pageApi.get(this.$route.params.pageId).then(data => {
        // console.log(data);
        this.page = data;
      });
    }

  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.formInfo {
  @include form-info;
}

.userDd {
  padding: 10px 0;
}

.list {
  overflow: hidden;
}
</style>